<template lang="html">
   <div class="test-form">
      <div class="my-5 row justify-content-md-center" style="margin: 0">
         <div class="col-12 col-md-11 col-lg-10 col-xl-9">
            <div class="btn btn-primary" @click="submitForm()">
               Click Me! <span v-show="loading">Loading</span>
            </div>

            <Table 
               :table_fields="Product.tables.product.table_fields" 
               :table_data="products" 
               :title="Product.tables.product.title" 
               :search_fields="Product.tables.product.search_fields"
               :row_data="Product.tables.product.row_data"
               @on-action="submitForm"
            />
            <Table 
               :hasBody="true"
               :hasHead="true"
               :hasAction="true"
               :icon="Product.tables.product.icon" 
               :table_data="products" 
               :title="Product.tables.product.title" 
               :search_fields="Product.tables.product.search_fields"
               :row_data="Product.tables.product.row_data"
               @data-change="refreshData"
               @on-empty="onEmptyData"
            >
               <template slot="thead">
                  <tr>
                     <th>Image</th>
                     <th>Name</th>
                     <th>Code</th>
                     <th>Class</th>
                     <th>Sub Class</th>
                     <th>Status</th>
                     <th>Action</th>
                  </tr>
               </template>
               <template slot="tbody" v-for="data in table_data">
                  <tr>
                     <td>
                        <img :src="data.logo" alt="" style="max-height: 40px;width: auto; height: auto;">
                     </td>
                     <td>{{data.product_name}}</td>
                     <td>{{data.product_code}}</td>
                     <td>{{data.class[0].class_code}}</td>
                     <td>{{data.class[0].sub_class_code}}</td>
                     <td>{{data.status}}</td>
                  </tr>
               </template>
            </Table>
         </div>
      </div>
   </div>
</template>

<script>
import product from "./resources/stores/product.store";

export default {
   beforeDestroy () {
      this.$store.unregisterModule('product')
   },
   created(){
      utils.registerModule('product',product,this.$store)
   },
   components:{
      Table: () => import("@/libs/clarks/components/table/table"),
      Dropdown: () => import("@/libs/clarks/components/dropdown/dropdown"),
      DropdownItem: () => import("@/libs/clarks/components/dropdown/dropdown-item"),
      DropdownMenu: () => import("@/libs/clarks/components/dropdown/dropdown-menu"),
   },
   computed: {
      ...mapGetters([
         'Product',
         'products',
         'table_data',
         'loading'
      ])
   },
   methods: {
      ...mapActions([
         'submitForm',
      ]),
      onEmptyData(){

      },
      refreshData(){

      }
   },
   mounted(){
      utils.registerModule('product',product,this.$store)
   }
}
</script>

<style lang="scss">
   .test-form{
      
   }
</style>